module.exports = __webpack_public_path__ + "img/Ill_Badge_Action-Success.abac8fd6.svg";